import './index.less';
import React from 'react';
import { Button, Input } from 'antd';
import { connect } from 'react-redux';
import { translate, translateClear } from '../../store/actions/schedule.js';

const { TextArea } = Input;
const sty = {
  0: 'star one',
  1: 'star two',
  2: 'star three',
  3: 'star two',
  4: 'star one',
}
const sty1 = {
  0: 'star select one',
  1: 'star select two',
  2: 'star select three',
  3: 'star select two',
  4: 'star select one',
}

@connect(
  state => ({
    user: state.get('user').get('userInfo'),
    offset: state.get('user').get('offset'),
    excellent: state.get('schedule').get('excellent'),
    homework: state.get('schedule').get('homework'),
    insufficiency: state.get('schedule').get('insufficiency')
  }), {
    translate,
    translateClear
  }
)
class Feedback extends React.Component {

  componentWillUnmount() {
    const { translateClear } = this.props;
    translateClear();
  }

  star = (num) => {
    let dom = [];
    for (let i = 0; i < 5; i ++) {
      if (i < num) {
        dom.push(<div key={i} className={this.select(i)}></div>)
      } else {
        dom.push(<div key={i} className={this.normal(i)}></div>)
      }
    }
    return dom;
  }

  normal = (i) => {
    return sty[i];
  }

  select = (i) => {
    return sty1[i];
  }

  render() {
    const { data, excellent, homework, insufficiency, translate, handleCancel } = this.props;
    return (
        <div>
        <div className='content-item stars'>
          {this.star(data.star)}
        </div>
        <div className='content-item flex'>
          <span className='contentName'>优点</span> 
          <div className='row'>
            <TextArea style={{resize: 'none'}} readOnly rows={4} value={data.excellent} resize="false"/>
            {
              data.excellent ? <img className='translate' onClick={() => translate({q: data.excellent}, 'excellent')} src={require('../../assets/images/translate.png')} alt=""/> : null
            }
          </div>
          {
            excellent ? (<div className='trans'>
            <p>{excellent}</p>
          </div>) : null
          }
        </div>
        <div className='content-item flex'>
          <span className='contentName'>不足</span> 
          <div className='row'>
            <TextArea style={{resize: 'none'}} readOnly rows={4} value={data.insufficiency} resize="false"/>
            {
              data.insufficiency ? <img className='translate' onClick={() => translate({q: data.insufficiency}, 'insufficiency')} src={require('../../assets/images/translate.png')} alt=""/> : null
            }
          </div>
          {
            insufficiency ? (<div className='trans'>
            <p>{insufficiency}</p>
          </div>) : null
          }
        </div>
        <div className='content-item flex'>
          <span className='contentName'>课后作业</span> 
          <div className='row'>
            <TextArea style={{resize: 'none'}} readOnly rows={4} value={data.homework} resize="false"/>
            {data.homework 
              ? <img className='translate' onClick={() => translate({q: data.homework}, 'homework')} src={require('../../assets/images/translate.png')} alt=""/> : null
            }
          </div>
          {
            homework ? (<div className='trans'>
            <p>{homework}</p>
          </div>) : null
          }
        </div>
        <div className='dialog-btn'>
          <Button className='confirmbtn' onClick={() => handleCancel()}>确 定</Button>
        </div>
      </div>
    )
  }
}

export default Feedback;


// WEBPACK FOOTER //
// ./src/components/dialog/feedBack.jsx